var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"TopBanners"}},[(_vm.isFirstPage)?[_c('Banner',{attrs:{"bannerType":"bm-dsk_top"}}),_c('Banner',{attrs:{"bannerType":"bm-mob_top"}})]:_vm._e(),(_vm.windowSize.width > 1520)?_c('Banner',{attrs:{"bannerType":"bm-lb1"}}):_c('Banner',{attrs:{"bannerType":"bm-lb2"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }